import { render, staticRenderFns } from "./PlanType.vue?vue&type=template&id=45649004&scoped=true"
import script from "./PlanType.js?vue&type=script&lang=js&external"
export * from "./PlanType.js?vue&type=script&lang=js&external"
import style0 from "./PlanType.vue?vue&type=style&index=0&id=45649004&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45649004",
  null
  
)

export default component.exports